import React from 'react';
import { Card, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { fetchFileDownload } from '../../api/services';
import '../../assets/iconfont.css';
import './StandardCard.css';
import { formatDate, formatSize } from '../../utils/utils';
import { useIntl } from 'react-intl';

const StandardCard = ({
  file,
  mark,
  updateIndex,
  updateIsShow,
  currentIndex,
  isShow,
  title,
  isHandbook = false
}) => {
  const { name, size, release_date, doc_id, external_url = '', downloadUrl } = file;
  const intl = useIntl();
  const navigate = useNavigate();
  const firmwareText = intl.formatMessage({ id: 'Firmware' });

  // 处理文件下载或跳转
  const handleFileAction = async (e) => {
    if (e) {
      e.stopPropagation();
    }

    // 如果是产品手册，直接打开链接
    if (isHandbook) {
      window.open(downloadUrl || external_url, '_blank');
      return;
    }

    // 如果是手册且是语雀链接
    if (title === '手册' && external_url?.includes('yuque.com')) {
      const encodedInfo = encodeURIComponent(`${external_url}||${name}`);
      navigate(`/download/${encodedInfo}`);
      return;
    }

    // 其他情况
    if (external_url) {
      window.open(external_url, '_blank');
    } else {
      try {
        const res = await fetchFileDownload(doc_id);
        if (res.status === 200) {
          window.open(res.result.url, '_blank');
        }
      } catch (error) {
        console.error('Download error:', error);
      }
    }
  };

  // 卡片点击处理
  const handleCardClick = () => {
    // 如果是固件，则执行原有的逻辑
    if (title === firmwareText) {
      updateIndex(mark);
      if (currentIndex === mark) {
        updateIsShow(!isShow);
      } else {
        updateIsShow(true);
      }
    } else {
      // 非固件直接触发下载
      handleFileAction();
    }
  };

  // 计算卡片样式
  const cardClass = currentIndex === mark && isShow
    ? {
        title: classNames('file-title', 'file-title-active'),
        clicked: 'card-selected',
        icon_font: 'icon-active',
        icon: 'icon-active',
      }
    : {
        title: 'file-title',
        clicked: '',
        icon_font: '',
        icon: '',
      };

  // 如果是产品手册，使用简化版的卡片
  if (isHandbook) {
    return (
      <div onClick={handleFileAction}>
        <Card>
          <div className='card-content'>
            <div className='card-content-left'>
              <div className='file-title' title={name}>
                {name}
              </div>
            </div>
            <div className='download'>
              <i
                className='iconfont icon-download'
                onClick={handleFileAction}
                style={{ cursor: 'pointer' }}
              />
            </div>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div onClick={handleCardClick}>
      <Card className={cardClass.clicked}>
        <div className='card-content'>
          <div className='card-content-left'>
            <div className={cardClass.title} title={name}>
              {name}
            </div>
            {!external_url && (
              <Space>
                <i className={`iconfont icon-TimeCircle ${cardClass.icon}`}>
                  <span className={cardClass.icon_font}>
                    {formatDate(release_date)}
                  </span>
                </i>
                <i className={`iconfont icon-folderopen ${cardClass.icon}`}>
                  <span className={cardClass.icon_font}>
                    {formatSize(size)}
                  </span>
                </i>
              </Space>
            )}
          </div>
          <div className={`download ${cardClass.icon}`}>
            <i
              className='iconfont icon-download'
              onClick={handleFileAction}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default StandardCard;
